import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import {
  useGetAllTelegramIdsByLicense,
  useGetAllTelegramIdsByLicenseCount,
} from '../../../../services/TelegramIdsService/hooks/useQuery';
import { IPaginationParams } from '../../../../services/types';
import React, { useContext, useState } from 'react';
import {
  ITelegramIdsFilterProps,
  ITelegramIdsProps,
  ITelegramIdsSimpleProps,
} from '../../../../services/TelegramIdsService/types';
import ButtonActionsComponent from '../../../../components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from '../../../../components/ConfirmDeleteModalComponent';
import {
  useDeleteTelegramId,
  useGetTelegramIdById,
} from '../../../../services/TelegramIdsService/hooks/useMutation';
import { AppContext } from '../../../../context/AppContextProvider';
import TelegramIdEditionModal from './TelegramIdEditionModal';
import ButtonComponent from '../../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';

const TelegramIdsManagementTab = () => {
  const [isVisibleDeletionModal, setIsVisibleDeletionModal] =
    useState<boolean>(false);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [filter, setFilter] = useState<ITelegramIdsFilterProps>({
    name: '',
    telegramId: '',
  });
  const [selectedItem, setSelectedItem] = useState<ITelegramIdsSimpleProps>();
  const {
    data: telegramIds,
    refetch: refetchTelegramIds,
    isLoading: isLoadingTelegramIds,
  } = useGetAllTelegramIdsByLicense(pagination, filter);
  const {
    data: telegramIdsCounts,
    refetch: refetchCount,
    isLoading: isLoadingCount,
  } = useGetAllTelegramIdsByLicenseCount(pagination, filter);
  const { mutateAsync: mutateDeleteTelegramId } = useDeleteTelegramId();
  const { mutateAsync: mutateGetTelegramId } = useGetTelegramIdById();
  const { showSnackbar } = useContext(AppContext);
  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
    },
    {
      id: 'telegramId',
      label: 'ID Telegram',
    },
    {
      id: 'id',
      align: 'center',
      width: '0px',
      label: 'Ações',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleConfirmDeletion = async () => {
    if (selectedItem?.id)
      mutateDeleteTelegramId(selectedItem?.id).then(() => {
        showSnackbar('Contato do Telegram excluído com sucesso.', 'success');
        setSelectedItem(undefined);
        setIsVisibleDeletionModal(false);
        refetchAll();
      });
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeletionModal(false);
    setSelectedItem(undefined);
  };

  const handleDeleteItem = (id: number) => {
    if (telegramIds) {
      setSelectedItem(telegramIds.find((t) => t.id === id));
      setIsVisibleDeletionModal(true);
    }
  };

  const handleEdit = async (id: number) => {
    await mutateGetTelegramId(id).then((data: ITelegramIdsProps) => {
      setSelectedItem(data);
      setIsVisibleEditionModal(true);
    });
  };

  const handleSaveForm = () => {
    setSelectedItem(undefined);
    refetchAll();
  };

  const refetchAll = async () => {
    await refetchTelegramIds();
    await refetchCount();
  };

  return (
    <>
      <TableComponent
        rows={telegramIds ?? []}
        columns={columns}
        isLoading={isLoadingTelegramIds || isLoadingCount}
        onChangePageOrRowsPerPage={setPagination}
        totalCount={telegramIdsCounts}
        title={'Contatos Telegram'}
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Novo Contato
          </ButtonComponent>
        }
        onChangeMainFilter={(val) =>
          setFilter((oldSt) => ({ ...oldSt, name: val }))
        }
        onSubmitMainFilter={refetchAll}
      />
      <ConfirmDeleteModalComponent
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
        isVisibleDeleteDialog={isVisibleDeletionModal}
        message={`Deseja deletar o contato ${selectedItem?.name} (${selectedItem?.telegramId}) ?`}
        setIsVisibleDeleteDialog={setIsVisibleDeletionModal}
        title={'Deletar Contato do Telegram'}
      />
      <TelegramIdEditionModal
        selectedItem={selectedItem}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
        handleForm={handleSaveForm}
      />
    </>
  );
};

export default TelegramIdsManagementTab;
